import { onClickhref } from "utils";
import styles from "../index.less";

const DepartHead = ({ data, departInfo }: any) => {
  return <div className={styles.departHeadInfo}>
  <p
    onClick={() => onClickhref(`/hospital/${data.hospitalId}`)}
    data-a-href={`/hospital/${data.hospitalId}`}
  >{data?.hospitalName}</p>
  <h1>{departInfo?.departName}</h1>
</div>
}

export default DepartHead;
